<h2 mat-dialog-title>{{ 'Holiday' | translate: {Default: "Holiday"} }}</h2>

<mat-dialog-content>
    <ng-container *ngIf="isLoading; else loaded">
        <div style="width:100%">
            <ngx-skeleton-loader
                    count="5"
                    [theme]="{
                'height.px': 50,
                'width.px': 50
            }"
            ></ngx-skeleton-loader>
        </div>
    </ng-container>

    <ng-template #loaded>
        <div class="form" *ngIf="form" [formGroup]="form">
            <app-localization-text-form-field
                [formElement]="{ formControl: 'localizations', localizationValueParam: 'text', text: ('HolidayName' | translate: {Default: 'Holiday name'}), disabled: 'false' }"
                [parentGroup]="form"
                [cultures]="allCultures"
                [showTitle]="false"
                [hideUsedCultures]="true"
                (emitAddtoFormArray)="addNewLocalization()"
                (emitDeleteFromFormArray)="deleteLocalization($event.index)"
            ></app-localization-text-form-field>

            <div class="k-d-flex k-d-flex-row k-justify-content-between">
                <mat-form-field appearance="fill" class="k-mr-3">
                    <mat-label>
                        Start Date
                    </mat-label>

                    <input matInput [matDatepicker]="startDateDatepicker" formControlName="startDate">
                    <span fxLayout="row" matSuffix>
                        <mat-datepicker-toggle [for]="startDateDatepicker"></mat-datepicker-toggle>
                    </span>
                    <mat-datepicker #startDateDatepicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>
                        End Date
                    </mat-label>

                    <input matInput [matDatepicker]="endDateDatepicker" formControlName="endDate" [min]="this.form.value.startDate">
                    <span fxLayout="row" matSuffix>
                        <mat-datepicker-toggle [for]="endDateDatepicker"></mat-datepicker-toggle>
                    </span>
                    <mat-datepicker [startAt]="this.form.value.startDate"  #endDateDatepicker></mat-datepicker>
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="fill" class="k-mr-3">
                    <mat-label>
                        Hour Override
                    </mat-label>

                    <input matInput
                           type="number"
                           min="1"
                           max="99999"
                           formControlName="hourOverride"
                           placeholder="1"
                    >
                </mat-form-field>
            </div>

            <mat-form-field appearance="fill">
                <mat-label>
                    Notes
                </mat-label>

                <input matInput formControlName="notes">
            </mat-form-field>


        </div>
    </ng-template>

</mat-dialog-content>

<mat-dialog-actions *ngIf="form">
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid">Save</button>
</mat-dialog-actions>
